import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e853b1f6")

_pushScopeId("data-v-e853b1f6")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "icon-cancel" })
], -1)
const _hoisted_2 = { class: "dialog__content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "dialog__title" }, "Intégrer la ligue", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withId(() => [
      (_ctx.joinTeamDialogVisible)
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            showHeader: false,
            tabindex: "0",
            onClose: _ctx.closeDialog,
            onKeydown: _withKeys(_ctx.closeDialog, ["esc"])
          }, {
            body: _withId(() => [
              _createVNode("div", {
                class: "button button--minimal close__button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
              }, [
                _hoisted_1
              ]),
              _createVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode("div", { innerHTML: _ctx.msg }, null, 8, ["innerHTML"])
              ])
            ]),
            _: 1
          }, 8, ["onClose", "onKeydown"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})